import validate from "/workspace/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirects_45global from "/workspace/layers/admin-panel/middleware/redirects.global.ts";
import manifest_45route_45rule from "/workspace/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirects_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "app-auth": () => import("/workspace/layers/auth/middleware/app-auth.ts"),
  "sidebase-auth": () => import("/workspace/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}